// @givmo/board — the two things the Board Ask's director page RENTS from other packages (EMC-WEB4):
// the share kit (`@givmo/org-console`'s `ShareKit`, built once for every sharing surface) and the
// fundraiser page wizard (`@givmo/fundraisers-module`'s `FundraiserPageWizard`). The host hands them
// in, so the Board package depends on neither: the console's director route provides both.
// With no slot provided, the page shows what it can without that part.

import { createContext, use, type ReactNode } from 'react';

export interface AskShareKitProps {
  /** The campaign; the kit's ONE link points at her own page once she has one. */
  campaignId: string;
  /** The ask's graphics, shown and downloadable in the kit. */
  collateralItemIds: string[];
  /** Inside "Your fundraiser page": no card of its own. */
  bare?: boolean;
  /** Called after she copies or downloads something, or opens "Email your contacts". */
  onShared: () => void;
}

export interface AskPageWizardProps {
  campaignId: string;
  /** Her page, to edit it; absent to create it. */
  existing?: { supporterId: string; fundraiserId: string };
  onBack: () => void;
  onExit: () => void;
  /** Her page was made or changed. */
  onPageChanged: () => void;
}

export interface AskSlots {
  renderShareKit?: (props: AskShareKitProps) => ReactNode;
  renderPageWizard?: (props: AskPageWizardProps) => ReactNode;
  /** Her page's public address, for "See your page". */
  pageUrl?: (fundraiserId: string) => string;
}

const AskSlotsContext = createContext<AskSlots>({});

export function BoardAskSlotsProvider({
  slots,
  children,
}: {
  slots: AskSlots;
  children: ReactNode;
}) {
  return <AskSlotsContext value={slots}>{children}</AskSlotsContext>;
}

export function useAskSlots(): AskSlots {
  return use(AskSlotsContext);
}
